/*
 * Flash sale clock, shared by the flash sale page, the product cards and the product page.
 *
 * A sale ends, and the next one starts, every Monday at 10:00 French time. The week is computed in the
 * Europe/Paris time zone (not a fixed +0100), so the clock changes in March and October are handled.
 */
(function () {
  if (window.FlashSale) return;

  var TZ = 'Europe/Paris';
  var END_WEEKDAY = 1; // Monday
  var END_HOUR = 10;
  var DAY_MS = 86400000;
  var WEEKDAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  var formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: TZ,
    weekday: 'short',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hourCycle: 'h23',
  });

  // Wall clock in Paris at a given instant.
  function parisParts(epoch) {
    var out = {};
    formatter.formatToParts(new Date(epoch)).forEach(function (p) {
      if (p.type !== 'literal') out[p.type] = p.value;
    });
    return {
      weekday: WEEKDAYS[out.weekday],
      year: +out.year,
      month: +out.month,
      day: +out.day,
      hour: +out.hour,
      minute: +out.minute,
      second: +out.second,
    };
  }

  // Paris offset from UTC, in ms, at a given instant (+1h in winter, +2h in summer).
  function parisOffset(epoch) {
    var p = parisParts(epoch);
    return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - Math.floor(epoch / 1000) * 1000;
  }

  // Instant of a Paris wall clock time. The guess is corrected twice so that it is right on both sides of a clock change.
  function parisWallToEpoch(year, month, day, hour) {
    var guess = Date.UTC(year, month - 1, day, hour, 0, 0);
    var epoch = guess - parisOffset(guess);
    return guess - parisOffset(epoch);
  }

  // Next Monday 10:00 Paris strictly after `now`.
  function nextEnd(now) {
    now = now === undefined ? Date.now() : now;
    var p = parisParts(now);
    var days = (END_WEEKDAY - p.weekday + 7) % 7;
    if (days === 0 && p.hour >= END_HOUR) days = 7;
    // Date.UTC rolls the day over the end of a month by itself
    var target = new Date(Date.UTC(p.year, p.month - 1, p.day + days));
    return parisWallToEpoch(target.getUTCFullYear(), target.getUTCMonth() + 1, target.getUTCDate(), END_HOUR);
  }

  function parts(ms) {
    var total = Math.max(0, Math.floor(ms / 1000));
    return {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60,
    };
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  // "2j 10h 43:21", and "10h 43:21" on the last day. dayUnit is "j" in French, "d" in English.
  function format(ms, dayUnit) {
    var t = parts(ms);
    return (t.days > 0 ? t.days + (dayUnit || 'j') + ' ' : '') + t.hours + 'h ' + pad(t.minutes) + ':' + pad(t.seconds);
  }

  // Every [data-flash-countdown] element on the page (cards, product page) shows the time left in the
  // current sale. One shared timer drives them all. is-last-day is set for the last 24 hours.
  function tickCounters() {
    var counters = document.querySelectorAll('[data-flash-countdown]');
    if (!counters.length) return;
    var now = Date.now();
    var left = nextEnd(now) - now;
    var text = {};
    counters.forEach(function (el) {
      var unit = el.getAttribute('data-day-unit') || 'j';
      el.textContent = text[unit] || (text[unit] = format(left, unit));
      el.classList.toggle('is-last-day', left < DAY_MS);
    });
  }

  window.FlashSale = {
    nextEnd: nextEnd,
    parts: parts,
    format: format,
    pad: pad,
    // Last 24 hours of the sale: the product page counter turns red.
    isLastDay: function (ms) {
      return ms < DAY_MS;
    },
    DAY_MS: DAY_MS,
    tickCounters: tickCounters,
  };

  function start() {
    tickCounters();
    setInterval(tickCounters, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
